// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Client V2 common imports
const { navigate } = require('client-v2/common/state/router/actions')
// Container imports
const AppNav = require('./component-dumb')

function mapStateToProps(state) {
  if (!state.user.loggedIn) {
    // Hide the nav bar for logged-out users
    return { hidden: true, items: [] }
  }
  // Determine selected state
  return {
    // Flags
    hidden: state.env.nativeEmbedded,
    // Values
    items: navItems(state),
    selected: selectedNavItemId(state)
  }
}

const mapDispatchToProps = {
  onNavigate: navigate
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  AppNav
)

// Helpers

const navItems = createSelector(
  () => {
    return [
      {
        id: 'for-you',
        title: 'For you',
        href: '/for-you',
        aliases: [
          '/',
          '/add',
          '/mixit',
          '/top-for-you'
        ]
      },
      {
        id: 'following',
        title: 'Following',
        href: '/following',
        aliases: [
          '/recently-added'
        ]
      },
      {
        id: 'popular',
        title: 'Popular',
        href: '/popular',
        aliases: [
          '/mix',
          '/interests',
          '/collections',
          '/people',
          '/explore',
          '/explore/interests',
          '/explore/collections',
          '/explore/people'
        ]
      }
    ]
  }
)

const selectedNavItemId = createSelector(
  [
    navItems,
    state => state.router.location.pathname
  ],
  (navItems, pathname) => {
    for (let item of navItems) {
      if (item.href === pathname || item.aliases.includes(pathname)) {
        return item.id
      }
    }
  }
)
